import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Layout from '../../../layout/Layout';
import RoleCard from '../../../components/RoleCard/RoleCard';
import AddNewRoleCard from '../../../components/AddNewRoleCard/AddNewRoleCard';
import getRoles from '../../../thunks/roles/getRoles';
import RolesSkeleton from './RolesSkeleton';
import RoleModal from './components/RoleModal';
import PermissionsGate from '../../../components/PermissionsGate/PermissionsGate';
import { permissions } from '../../../common/permissionGroup';
import AccessDenied from '../../../components/AccessDenied/AccessDenied';
import routes from '../../../router/routes';

const containerClassName = 'flex flex-row flex-wrap w-full';
const itemClassName = 'basis-1/3 mb-[30px]';
const itemContentClassName = 'px-[15px]';

const Roles = () => {
  const [roleModalVisibility, setRoleModalVisibility] = useState(false);
  const [editRole, setEditRole] = useState(undefined);
  const [activePermissions, setActivePermissions] = useState([]);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const {
    getRoles: {
      roles, loading
    },
  } = useSelector((state) => ({
    getRoles: state?.getRoles,
  }), shallowEqual);

  useEffect(() => {
    if (!roles) {
      dispatch(getRoles());
    }
  }, [roles]);

  const onButtonEdit = (item) => {
    if (item) {
      setEditRole(item);
    } else {
      setEditRole(undefined);
      setActivePermissions([]);
    }
    setRoleModalVisibility(true);
  };

  const onButtonView = (item) => navigate(`${routes.ROLES}/${item?.id}`);

  const breadcrumbs = {
    pageTitle: 'Roles',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'User management',
      },
      {
        title: 'Roles',
      }
    ]
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      {loading ? <RolesSkeleton />
        : (
          <PermissionsGate can={permissions.ROLES_READ} errorComponent={<AccessDenied />}>
            <div className={containerClassName}>
              {roles?.map((item) => (
                <div className={itemClassName} key={item?.id}>
                  <div className={itemContentClassName}>
                    <RoleCard item={item} onButtonEdit={onButtonEdit} onButtonView={() => onButtonView(item)} />
                  </div>
                </div>
              ))}
              <PermissionsGate can={permissions.ROLES_CREATE}>
                <div className={itemClassName}>
                  <div className={itemContentClassName}>
                    <AddNewRoleCard onClick={onButtonEdit} />
                  </div>
                </div>
              </PermissionsGate>
            </div>
          </PermissionsGate>
        )}
      <RoleModal
        visible={roleModalVisibility}
        toggleVisible={() => setRoleModalVisibility(false)}
        editRole={editRole}
        activePermissions={activePermissions}
        setActivePermissions={setActivePermissions}
      />
    </Layout>
  );
};

export default Roles;
